import { EnvironmentColor } from "environments/components/EnvironmentColorSelector";
import { HashMap } from "../../shared/model/HashMap";

export enum AgentRegistrationMode {
    SelfHosted = "SelfHosted",
    Deployment = "Deployment",
    Cloud = "Cloud",
    StatefulSet = "StatefulSet"
}

export interface IAppReducerState {
    state: IAppReducerOwnState;
    dispatch: (payload: IAppReducerAction) => void;
}

export interface IAppReducerOwnState {
    environments: IEnvironment[];
    isLoading: boolean;
    userPermissions: HashMap<boolean>;
}

export type IAppReducerAction =
    | { type: "SET_ENVIRONMENTS", environments: IEnvironment[] }
    | { type: "SET_ISLOADING", isLoading: boolean }
    | { type: "SET_AGENT_GROUP_AGENTS_WITH_STATUS", agentViewModels: IAgentData[], agentGroupName: string }
    | { type: "GET_ENVIRONMENTS" };

export interface IEnvironment {
    id?: number;
    name?: string;
    displayName?: string;
    displayOrder?: number;
    color?: EnvironmentColor;
    agentGroups?: IAgentGroupData[];
    isNew?: boolean;
    requireMcpConfirmation?: boolean;
}

export interface IAgentGroupData {
    id?: number;
    name?: string;
    displayName?: string;
    connectionString?: string;
    configJson?: string;
    allowRunningTestProcesses: boolean;
    executionAgents?: IAgentData[];
    gatewayAgents?: IAgentData[];
    hasLimitedAgents?: false;
    agentRegistrationMode: AgentRegistrationMode;
    defaultExternalAddress?: string;
}

export interface IAgentData {
    isSupportedAgentVersion: boolean;
    reportedConnectionString: string; //nullable from server
    reportedIsLimitedAgent: boolean; //nullable from server
    isPrimaryAgent: boolean;
    reportedHttpsPort: string; //nullable from server
    configuredHttpsPort: string;
    reportedHttpPort: string; //nullable from server
    configuredHttpPort: string;
    reportedIsGateway: boolean;
    configuredIsGateway: boolean;
    agentVersion: string; //nullable from server
    currentVersion: string;
    friendlyUrl: string;
    id: number;
    name: string;    
    userName: string; //what is the purpose for this field?
    lastStatus: string;
    lastUpdated: string; //nullable from server
    errorEventDuringLastDay: boolean;
    errorReason?: string; //nullable from server
}

export interface IAgentSettings {
    id?: number;
    userName?: string;
    name?: string;
    password?: string;
    httpsTriggerPorts: string;
    httpTriggerPorts: string;
    sslCertificateThumbprint?: string;
    configJson?: string;
    agentGroup?: IAgentGroupData;
    friendlyUrl?: string;
    isGateway?: boolean;
}

export interface IAgentTrigger {
    agentTriggerViewModel: IAgentTriggerViewModel[];
    name: string;
    triggersActive: boolean;
    // These may be undefined for passthrough trigger
    processGuid: string | undefined;
    version: string | undefined;
}

export interface IAgentTriggerViewModel {
    triggerDescription: IAgentTriggerDescription;
    triggerGuid: string;
    triggerName: string;
    triggerType: string;
    triggerUri: string;
}

export interface IAgentTriggerDescription {
    generalDescription: Array<{ key: string, value: string }>;
    triggerPaths: string[];
}

export interface IAgentEvents {
    agentEvents: IAgentEvent[];
    currentPage: number;
    maxPages: number;
    totalEvents: number;
}

export interface IAgentEvent {
    category: number;
    id: number;
    eventId: number;
    level: string;
    message: string;
    source: string;
    utcTimestamp: string;
}